var _styled;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { IconImportant } from '@govuk-react/icons';
import { withWhiteSpace } from '@govuk-react/hoc';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, NTA_LIGHT, SPACING } from '@govuk-react/constants';
var StyledWarningText = styled('div')({
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  width: '100%'
});
var IconImportantWrapper = styled('div')({
  flex: 'none',
  height: '35px',
  marginRight: SPACING.SCALE_3,
  width: '35px'
});
var WarningTextWrapper = styled('strong')((_styled = {
  fontFamily: NTA_LIGHT,
  fontSize: FONT_SIZE.SIZE_16,
  fontWeight: 700,
  lineHeight: LINE_HEIGHT.SIZE_16,
  textTransform: 'none'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_19,
  lineHeight: LINE_HEIGHT.SIZE_19
}, _styled));
/**
 *
 * ### Usage
 *
 * Simple
 * ```jsx
 * <WarningText>Example</WarningText>
 * ```
 *
 * ### References:
 * - https://govuk-elements.herokuapp.com/typography/#typography-warning-text
 * - https://github.com/alphagov/govuk-frontend/tree/master/src/components/warning-text
 *
 */

var WarningText = function WarningText(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return React.createElement(StyledWarningText, props, React.createElement(IconImportantWrapper, null, React.createElement(IconImportant, null)), React.createElement(WarningTextWrapper, null, children));
};

export default withWhiteSpace({
  marginBottom: 0
})(WarningText);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/warning-text/es/index.js
// module id = 314
// module chunks = 0